import React, { FC, memo } from "react";

import { SocBindCallbackScreen } from "../";

export const BindFacebookRedirect: FC = memo(() => <SocBindCallbackScreen network="facebook" />);
